import { SessionManager } from "@codedrops/lib";

const manager = new SessionManager({ key: "octon" });

export default manager;
